import { useMemo } from 'react';

import { useGlobalContext } from '~/lib/contexts/GlobalContext';
import {
  CalendarTab,
  CalendarTabsCollection,
  CalendarTabsCollectionV2,
  getTabIndex,
} from '~/lib/util/calendar.util';
import { isAvailabilityAuthorized } from '~/lib/util/routes.util';
import { Path } from '~/routes/constants';

import CalendarPanels from './panels';
import { PortalComponent } from '../../../lib/contexts/ComponentPortalContext';
import Tabs from '../../common/tabs';
import { useFlags } from 'launchdarkly-react-client-sdk';

const CalendarTabs = () => {
  const { permissions } = useGlobalContext();
  const { groupsRestructuring: isGroupsRestructuringEnabled } = useFlags();

  const tabsDictionary = useMemo<Record<CalendarTab, TabDefinition>>(() => {
    const tabs: Record<CalendarTab, TabDefinition> = {
      ...CalendarTabsCollectionV2,
    };

    if (!isAvailabilityAuthorized(permissions)) {
      tabs[CalendarTab.AVAILABILITY].isDisabled = true;
    }

    tabs[CalendarTab.GROUP].isHidden = !isGroupsRestructuringEnabled;
    tabs[CalendarTab.GROUP_CLASS].isHidden = isGroupsRestructuringEnabled;

    return tabs;
  }, [permissions, isGroupsRestructuringEnabled]);

  return (
    <Tabs<CalendarTab>
      basePath={Path.CALENDAR}
      componentPortalContextKey="saveAvailability"
      defaultPath={CalendarTabsCollection[CalendarTab.SCHEDULE].subPath}
      getTabIndex={getTabIndex}
      Panels={CalendarPanels}
      portalComponent={PortalComponent.SAVE_AVAILABILITY}
      tabsDictionary={tabsDictionary}
      tabsStyles={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        paddingTop: '0px',
      }}
      title="Calendar"
    />
  );
};

export default CalendarTabs;
